import { lighten } from '@material-ui/core'

import { merge } from 'lodash-es'

import { getBaseLightPerceptThemeOptions, getBaseDarkPerceptThemeOptions } from './perceptAppThemeV2'

/*

Incubeta palette gleaned from website at https://incubeta.com/

primary: '#9901FF',
secondary: '#FF9637',
text: #434343;
accent: #911E90;
1410803: #5802F7;
f349090: #9F9F9F;
4dd2aea: #FFFFFF;
7490279: #000000;
--wp--preset--color--cyan-bluish-gray: #abb8c3;
--wp--preset--color--white: #ffffff;
--wp--preset--color--pale-pink: #f78da7;
--wp--preset--color--vivid-red: #cf2e2e;
--wp--preset--color--luminous-vivid-orange: #ff6900;
--wp--preset--color--luminous-vivid-amber: #fcb900;
--wp--preset--color--light-green-cyan: #7bdcb5;
--wp--preset--color--vivid-green-cyan: #00d084;
--wp--preset--color--pale-cyan-blue: #8ed1fc;
--wp--preset--color--vivid-cyan-blue: #0693e3;
--wp--preset--color--vivid-purple: #9b51e0;
--wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(135deg, rgba(6, 147, 227, 1) 0%, rgb(155, 81, 224) 100%);
--wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(135deg, rgb(122, 220, 180) 0%, rgb(0, 208, 130) 100%);
--wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(135deg, rgba(252, 185, 0, 1) 0%, rgba(255, 105, 0, 1) 100%);
--wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(135deg, rgba(255, 105, 0, 1) 0%, rgb(207, 46, 46) 100%);
--wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(135deg, rgb(238, 238, 238) 0%, rgb(169, 184, 195) 100%);
--wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(135deg, rgb(74, 234, 220) 0%, rgb(151, 120, 209) 20%, rgb(207, 42, 186) 40%, rgb(238, 44, 130) 60%, rgb(251, 105, 98) 80%, rgb(254, 248, 76) 100%);
--wp--preset--gradient--blush-light-purple: linear-gradient(135deg, rgb(255, 206, 236) 0%, rgb(152, 150, 240) 100%);
--wp--preset--gradient--blush-bordeaux: linear-gradient(135deg, rgb(254, 205, 165) 0%, rgb(254, 45, 45) 50%, rgb(107, 0, 62) 100%);
--wp--preset--gradient--luminous-dusk: linear-gradient(135deg, rgb(255, 203, 112) 0%, rgb(199, 81, 192) 50%, rgb(65, 88, 208) 100%);
--wp--preset--gradient--pale-ocean: linear-gradient(135deg, rgb(255, 245, 203) 0%, rgb(182, 227, 212) 50%, rgb(51, 167, 181) 100%);
--wp--preset--gradient--electric-grass: linear-gradient(135deg, rgb(202, 248, 128) 0%, rgb(113, 206, 126) 100%);
--wp--preset--gradient--midnight: linear-gradient(135deg, rgb(2, 3, 129) 0%, rgb(40, 116, 252) 100%);

*/


const incubetaGenericChartColours: string[] = [
  'rgb(207, 46, 46)',
  '#5802F7',
  '#0693e3',
  '#9901FF',
  '#FF9637',
  '#434343',
  '#911E90',
]


export const incubetaLightThemeOptions = merge(
  getBaseLightPerceptThemeOptions({
    themePalette: {
      primary: '#9901FF',
      secondary: '#FF9637',
      neutral: '#434343',
      info: '#0693e3',
      text: '#333',
      success: 'rgb(0, 208, 130)',
      warning: 'rgba(252, 185, 0, 1)',
      error: 'rgb(207, 46, 46)',
      background: '#f5f5f5',
      paper: 'rgb(238, 238, 238)',
      contrastPanel: '#434343',
      infoRangeStart: 'rgb(6, 147, 227)',
      infoRangeStop: 'rgb(155, 81, 224)',
    },
    genericChartColours: incubetaGenericChartColours,
  }),
  {
    palette: {
      secondary: {
        contrastText: '#FFF',
      },
    },
  }
)


export const incubetaDarkThemeOptions = merge(
  getBaseDarkPerceptThemeOptions({
    themePalette: {
      primary: '#9901FF',
      secondary: '#FF9637',
      neutral: '#434343',
      info: '#0693e3',
      text: '#FFF',
      success: 'rgb(0, 208, 130)',
      warning: 'rgba(252, 185, 0, 1)',
      error: 'rgb(207, 46, 46)',
      background: lighten('#353535', 0.075),
      paper: '#353535',
      contrastPanel: '#434343',
      infoRangeStart: 'rgb(6, 147, 227)',
      infoRangeStop: 'rgb(155, 81, 224)',
    },
    genericChartColours: incubetaGenericChartColours,
  }),
  {
    palette: {
      primary: {
        contrastText: '#FFF',
      },
      secondary: {
        contrastText: '#FFF',
      },
    },
  }
)
